import {
	PROMOTION_LIST,
	PROMOTION_LIST_SUCCESS,
	PROMOTION_LIST_ERROR,
	PROMOTION_SAVE,
	PROMOTION_SAVE_SUCCESS,
	PROMOTION_SAVE_ERROR,
	PROMOTION_DELETE,
	PROMOTION_DELETE_SUCCESS,
	PROMOTION_DELETE_ERROR,
} from '../actions-registry';

// payload: { merchantId, menuVersionId, branchId, onError }
export const listPromotions = (payload) => ({
	type: PROMOTION_LIST,
	payload,
});
export const listPromotionsSuccess = (list) => ({
	type: PROMOTION_LIST_SUCCESS,
	payload: list,
});
export const listPromotionsError = (message) => ({
	type: PROMOTION_LIST_ERROR,
	payload: message,
});

// payload: { merchantId, isEdit, promotionCode, request, onSuccess, onError }
export const savePromotion = (payload) => ({
	type: PROMOTION_SAVE,
	payload,
});
export const savePromotionSuccess = () => ({
	type: PROMOTION_SAVE_SUCCESS,
});
export const savePromotionError = (message) => ({
	type: PROMOTION_SAVE_ERROR,
	payload: message,
});

// payload: { merchantId, promotionCode, menuVersionId, onSuccess, onError }
export const deletePromotion = (payload) => ({
	type: PROMOTION_DELETE,
	payload,
});
export const deletePromotionSuccess = () => ({
	type: PROMOTION_DELETE_SUCCESS,
});
export const deletePromotionError = (message) => ({
	type: PROMOTION_DELETE_ERROR,
	payload: message,
});
